import { BodyM, Box, H3 } from '@otovo/rainbow';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { FormattedMessage as T } from 'react-intl';

import Link from '@otovo/shared/components/RainbowLinkLegacy/RainbowLinkLegacy';

import Spinner from '@otovo/shared/components/LoadingScreens/Spinner';

import useHasMounted from '@otovo/shared/hooks/useHasMounted';
import { validToken } from '../../utils/auth/auth';
import LoginForm from './LoginForm';
import PageWrapper from './PageWrapper';
import { getNextPath } from './getNextPath';
import useLogin from './hooks/useLoginUser';
import useProfile from './hooks/useProfile';
import m from './messages';

const LoginPage = () => {
  const router = useRouter();
  const [error, setError] = useState(null);
  const [isRedirecting, setIsRedirecting] = useState(false);
  const hasToken = validToken();
  const { trigger: loginUser, isLoggingIn } = useLogin();
  const { user } = useProfile({
    redirectToLogin: false,
  });

  // Avoids an hydration error
  const hasMounted = useHasMounted();

  useEffect(() => {
    if (!user) {
      return;
    }

    setIsRedirecting(true);
    const nextPath = getNextPath(router);
    router.replace(nextPath);
  }, [user, router]);

  const handleLogin = (username: string, password: string) => {
    loginUser(
      { username, password },
      {
        onError(err: Error) {
          setError(err);
        },
      },
    );
  };

  const handleFormChange = () => {
    setError(null);
  };

  if (!hasToken && !isRedirecting && hasMounted) {
    return (
      <PageWrapper>
        <Box mt="3" backgroundColor="white" mx="_6" p="6" borderRadius="3">
          <Box display="block" textAlign="right" mt="_3">
            <Link href="/password/new-user">
              <T {...m.newUserLabel} />
            </Link>
          </Box>

          <H3 mb="3" mt="6">
            <T {...m.title} />
          </H3>

          <LoginForm
            error={error}
            handleLogin={handleLogin}
            handleChange={handleFormChange}
            isLoggingIn={isLoggingIn}
          />

          <BodyM textAlign="center" mt="3">
            <Link href="/password/reset">
              <T {...m.forgottenPasswordTitle} />
            </Link>
          </BodyM>
        </Box>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <Box textAlign="center">
        <Spinner />
      </Box>
    </PageWrapper>
  );
};

export default LoginPage;
